/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Published_MisaInputs */

const vi_einvoice_published_misa = /** @type {(inputs: Einvoice_Published_MisaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã phát hành trên MISA`)
};

/**

* @param {Einvoice_Published_MisaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_published_misa = /** @type {((inputs?: Einvoice_Published_MisaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Published_MisaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_published_misa(inputs)
});